import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { ToDateTime } from '../utils/to-date-time';

export const startDateBeforeEndDateValidator =
  (endDateControlName = 'endDate', message = 'Start date must be on or before end date'): ValidatorFn =>
  (control: AbstractControl<Date | string | null>): ValidationErrors | null => {
    const startDate = ToDateTime(control.value);
    const endDate = ToDateTime(control.parent?.get(endDateControlName)?.value);

    if (startDate === null || endDate === null || startDate <= endDate) {
      return null;
    }

    return { isCustom: true, message };
  };
